import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Select } from '@interfaces';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UtilService {
  public downloadContractsExcel = new BehaviorSubject<number>(null);

  constructor(
    private snackBar: MatSnackBar,
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService
  ) { }

  public toastErrors(error, messageDefault: string = 'COMMONS.ERROR'): void {
    let message: string;
    if (error.status === 500 || error.status === 0) {
      message = this.i18NextService.t('COMMONS.CONNECTION_ERROR');
    } else if (error.status === 504) {
      message = this.i18NextService.t('COMMONS.TIME_OUT');
    } else {
      message = error.Info ? error.Info[0].Message : error.message ? error.message : this.i18NextService.t(messageDefault);
    }
    this.snackBar.open(message, 'x', { duration: 10000, panelClass: 'bg-error' });
  }

  public formatQueryParams(requestModel: any): string {
    const getValue = (key: string): string => {
      const value = (requestModel as Record<string, string>)[key];
      return Array.isArray(value)
        ? value.map(item => encodeURI((item as { id: string }).id)).join(',')
        : encodeURI(value);
    };
    const queryParams = Object.keys(requestModel)
      .map(key => `${encodeURI(key)}=${getValue(key)}`)
      .join('&');
    return queryParams ? `?${queryParams}` : '';
  }

  public formatDate(date: string | Date): string {
    const newDate = new Date(date);
    let day = '' + newDate.getDate();
    let month = '' + (newDate.getMonth() + 1);
    const year = newDate.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  public getListCountryMobile(): Select[] {
    return [
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.PORTUGAL'),
        value: '00351',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.SPAIN'),
        value: '0034',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.GERMANY'),
        value: '0049',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.AUSTRIA'),
        value: '0043',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.BELGIUM'),
        value: '0032',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.BULGARIA'),
        value: '00359',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.CZECH_REPUBLIC'),
        value: '00420',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.CYPRUS'),
        value: '00357',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.CROATIA'),
        value: '00385',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.DENMARK'),
        value: '0045',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.SLOVAKIA'),
        value: '00421',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.SLOVENIA'),
        value: '00386',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.ESTONIA'),
        value: '00372',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.FINLAND'),
        value: '00358',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.FRANCE'),
        value: '0033',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.GREECE'),
        value: '0030',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.HUNGARY'),
        value: '0036',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.IRELAND'),
        value: '00353',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.ITALY'),
        value: '0039',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.LATVIA'),
        value: '00371',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.LITHUANIA'),
        value: '00370',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.LUXEMBOURG'),
        value: '00352',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.MALTA'),
        value: '00356',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.NETHERLANDS'),
        value: '0031',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.POLAND'),
        value: '0048',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.ROMANIA'),
        value: '0040',
      },
      {
        label: this.i18NextService.t('NEW_CONTRACTS.MOBILE_COUNTRY_CODE.OPTION_LABEL.SWEDEN'),
        value: '0046',
      },
    ];
  }
}
